<template>
  <div class="switchWrapper">
    <div class="global-title">
      客户转化分析
      <el-button class="exportData" @click="exportFn">导出数据</el-button>
    </div>
    <div class="content">
      <div class="recom-title">
        <span class="divison"></span>
        <span class="name">客户转化模型</span>
        <el-popover placement="top-start" width="300" trigger="hover">
          <div>1.仅统计近30天的数据</div>
          <div>2.进店-浏览商详-加购-成交，代表用户行为的加深，而非严格漏斗关系，因此可能出现行为之间转化比例大于100%的情况</div>
          <span class="tipsIcon" slot="reference">?</span>
        </el-popover>
      </div>
      <!-- 客户转换模型 -->
      <div class="content-x">
        <div class="roi-line">
          <div class="roi-wrap">
          </div>
        </div>
        <div class="effect-box">
          <el-row>
            <el-col :span="21">
              <div class="data-chat">
                <div class="effect-bg-wrap">
                  <div class="effect-bg-box">
                    <img class="effect-bg" src="@/assets/images/home/1366.png" alt />
                    <img class="effect-bg-mini" src="@/assets/images/home/1367.png" alt />
                    <div class="com-box send-num">
                      <div class="num">{{ marketObj.enterStore }}</div>
                      <div class="text">进店人数</div>
                    </div>
                    <div class="com-box order-num">
                      <div class="num">{{ marketObj.viewDetail }}</div>
                      <div class="text">浏览商详人数</div>
                    </div>
                    <div class="com-box pay-num">
                      <div class="num">{{ marketObj.addToCart }}</div>
                      <div class="text">{{ venderType ? '加购人数' : '加购人数' }}</div>
                    </div>
                    <div class="com-box sucess-num">
                      <div class="num">{{ marketObj.deal }}</div>
                      <div class="text">{{ venderType ? '成交人数' : '成交人数' }}</div>
                    </div>

                    <div class="com-box order-rate">
                      <div class="num">{{ marketObj.viewRate || 0 }}</div>
                      <div class="text">浏览率</div>
                    </div>
                    <div class="com-box order-pay-rate">
                      <div class="num">{{ marketObj.addToCartRate || 0 }}</div>
                      <div class="text">加购率</div>
                    </div>
                    <div class="com-box success-pay-rate">
                      <div class="num">{{ marketObj.addToCartDealRate || 0 }}</div>
                      <div class="text">加购-成交率</div>
                    </div>
                    <div class="com-box pay-rate">
                      <div class="num">{{ marketObj.dealConversionRate || 0 }}</div>
                      <div class="text">成交转化率</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 入会趋势 -->
      <div class="recom-title">
        <span class="divison"></span>
        <span class="name">客户下单趋势</span>
      </div>
      <div class="trendDate">
        <el-radio v-model="trendRadio" label="7" @change="trendChooseChange">近7天</el-radio>
        <el-radio v-model="trendRadio" label="15" @change="trendChooseChange">近15天</el-radio>
        <el-radio v-model="trendRadio" label="30" @change="trendChooseChange">近30天</el-radio>
      </div>
      <div id="trend"></div>
    </div>
    <!-- 生成报表 -->
    <generate :control = 'control' 
              v-if="control" 
              @transData="(val) => (control = val)"
              @transData1 = 'getphone1'
    
              >
            
            
   </generate>



  </div>
</template>

<script>
import * as echarts from "echarts";
import { customerConversion, orderTrend, exportData,exportDataOne } from "@/api/analysis/people_switch.js";
import generate from '../../components/generate_report.vue'
export default {
  data() {
    return {
      control:false,
      trendX: [], // 趋势横坐标
      trendData: [], // 趋势图数据
      trendRadio: "7",
      venderType: true,
      marketObj: {
        addToCart: 0,
        addToCartDealRate: 0,
        addToCartRate: 0,
        deal: 0,
        dealConversionRate: 0,
        enterStore: 0,
        viewDetail: 0,
        viewRate: 0,
      },
    }
  },
  components: {
    generate
  },

  created() {
    this.customerConversion()
    this.orderTrend()

    // 埋点
    this.buriedPoint(1, '客户转化分析', '数据分析', '客户分析')
  },

  methods: {
    // 导出数据
    async exportFn() {
      this.control = true;
    },
    getphone1(val){
      let params = {
        days:this.trendRadio,
        exportRemark:val
      }
      exportDataOne(params).then((res)=>{
        if(res.code==1){
             this.control = true;
        }else{
          this.$message.error(res.message);
        }
      })
    },
    // 下单趋势
    async orderTrend(days = 7) {
      const { data } = await orderTrend({ days })
      data.forEach((item) => {
        this.trendX.push(item.orderDate)
        this.trendData.push(item.orderNum)
      })
      this.drawTrendBar();
    },

    // 客户转化分析汇总
    async customerConversion() {
      const { data } = await customerConversion()
      this.marketObj = data
    },

    trendChooseChange(val) {
      this.trendX = []
      this.trendData = []
      this.orderTrend(val)
    },

    // 绘制客户下单趋势图
    drawTrendBar() {
      let chartDom = document.getElementById("trend");
      let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: 10,
          left: 50,
        },
        xAxis: {
          type: "category",
          data: this.trendX,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: this.trendData,
            type: "line",
            labelLine: {
              length: 30,
            },
            itemStyle: {
            normal: {
              color: "#7F85E9",
              lineStyle: {
                  color: "#7F85E9"
                }
              }
            },
            label: {
              backgroundColor: "#F6F8FC",
              borderColor: "#8C8D8E",
              borderWidth: 1,
              borderRadius: 4,
              show: false,
            },
          },
          
        ],
      };
      option && myChart.setOption(option);
    },
  }
}
</script>

<style lang="scss" scoped>
.switchWrapper {
  min-width: 1130px;
  // height: 200px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 6px;
  margin: 20px;

  .exportData {
    float: right;
    margin-top: 12px;
    margin-right: 20px;
  }

  .content {
    margin: 20px 28px 0 28px;

    .trendDate {
      margin: 20px;
    }

    #trend {
      height: 320px;
      width: 100%;
    }

    .recom-title{
      position: relative;
      background-color: #FAFAFA;
      height: 32px;
      line-height: 32px;
      padding-right: 12px;
      .tipsIcon {
        position: absolute;
        display: inline-block;
        font-size: 12px;
        text-align: center;
        color: #ccc;
        line-height: 12px;
        border: 1px solid #ccc;
        width: 12px;
        height: 12px;
        border-radius: 12px;
        margin-left: 8px;
        top: 50%;
        transform: translateY(-50%);
      }

      .divison{
        vertical-align: middle;
        border-radius: 3px;
        width: 3px;
        height: 14px;
        background-color: #FE4D45;
        display: inline-block;
        margin: auto 4px auto 12px;
      }
      .name{
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #333;
      }
    }
  }

  .content-x {
    padding: 23px 0 32px 25px;
    margin-bottom: 80px;

    .roi-line {
      color: #333;

      .roi-wrap {
        font-size: 16px;
        font-weight: 500;
      }

      .rate {
        color: #fe4d45;
        font-family: Arial;
        font-weight: bold;
        font-size: 18px;
      }
    }

    .effect-box {
      .data-chat {
        // height: 325px;
        height: 268px;
        left: -50px;

        @media screen and (max-width: 1366px) {
          left: -25px;
        }

        position: relative;

        .effect-bg-wrap {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateY(-50%) translateX(-50%);

          .effect-bg-box {
            // width: 621px;
            height: 240px;
            position: relative;

            .effect-bg-mini {
              display: none;
            }

            .com-box {
              position: absolute;

              .num {
                font-size: 14px;
                color: #fe4d45;
              }

              .text {
                color: #000000;
                font-size: 12px;
              }
            }

            .send-num {
              top: 22px;
              left: -58px;
              font-weight: 500;
            }

            .order-num {
              left: -34px;
              top: 104px;
            }

            .pay-num {
              left: 30px;
              top: 186px;
            }

            .sucess-num {
              left: 70px;
              top: 270px;
            }

            .order-rate {
              left: 566px;
              top: 71px;
            }

            .order-pay-rate {
              left: 523px;
              top: 150px;
            }

            .success-pay-rate {
              left: 480px;
              top: 228px;
            }

            .pay-rate {
              top: 150px;
              right: -17px;
            }
          }
        }
      }

      .data-content {
        // border-left: 1px solid #f0f0f0;
        padding: 30px 0;

        .data-box {
          width: 70%;
          margin: 0 auto;
          // background-color: #f9f9f9;
          border-radius: 4px;
          padding-top: 37px;
          position: relative;

          .more {
            position: absolute;
            top: -40px;
            right: 0;
            color: #666666;
            font-size: 14px;
            cursor: pointer;

            span {
              vertical-align: middle;
            }

            .icon {
              display: inline-block;
              font-size: 12px;
              text-align: center;
              color: #ccc;
              line-height: 12px;
              border: 1px solid #ccc;
              width: 12px;
              height: 12px;
              border-radius: 12px;
              margin-left: 4px;
            }
          }

          .item {
            display: inline-block;
            width: 50%;
            padding-left: 10%;
            padding-bottom: 32px;

            .item-title {
              font-size: 13px;
              color: #999999;
            }

            .item-value {
              color: #333333;
              font-weight: bold;
              margin-top: 6px;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>